import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 9 17",
  "content": "<symbol viewBox=\"0 0 9 17\" id=\"icon-facebook\">\r\n<path d=\"M8.003,8.517H5.617v8.504H2.083V8.517H0.402V5.513h1.681V3.568C2.083,2.175,2.745,0,5.649,0l2.618,0.01\r\n\tv2.917h-1.9c-0.31,0-0.75,0.154-0.75,0.819v1.766h2.695L8.003,8.517z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/facebook.svg
// module id = ./app/general/svg/facebook.svg
// module chunks = app